import { useDropzone } from 'react-dropzone'

export default function Upload({ accept = '', onChange = () => {} }) {
  const { getRootProps, getInputProps } = useDropzone({
    accept,
    onDrop: onChange,
  })

  return (
    <div className="drop" {...getRootProps({ className: 'dropzone drop' })}>
      <input {...getInputProps()} />
      <i className="hb-ico drop-ico" />
      <span className="drop-title">Drag and drop</span>
      <span className="drop-or">-or-</span>
      <span className="second-btn second-btn__big">
        <i className="hb-ico plus-ico" />
        Upload
      </span>
    </div>
  )
}
